// Custom JS goes here ------------
console.log('-- crowtoes --');
function random(min,max) {
  const num = Math.floor(Math.random()*(max-min)) + min;
  return num;
}
function createCookie(name,value,days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		var expires = "; expires="+date.toGMTString();
	}
	else var expires = "";
	document.cookie = name+"="+value+expires+"; path=/";
}
function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}





(function($){
	function get_rotation_angle(el){
		// let rotate = document.getElementById('rotate');
		let style = window.getComputedStyle(el, null);
		let transform = style.getPropertyValue("-webkit-transform") ||
		style.getPropertyValue("-moz-transform") ||
		style.getPropertyValue("-ms-transform") ||
		style.getPropertyValue("-o-transform") ||
		style.getPropertyValue("transform") ||
		false;
		
		if ( transform ) {
			var values = transform.split('(')[1],
				values = values.split(')')[0],
				values = values.split(',');

			var [a,b,c,d] = values;
			var angle = Math.round(Math.atan2(b, a) * (180/Math.PI));
		} 

		return angle ? angle : false;
	}
	$(document).ready(function(){

		const builder = window.location.href.includes('et_fb=1') || window.location.href == 'about:blank';

		console.log(builder, window.location.href);

		// // Randomize the theme color...
		// // This should be moved to PHP to prevent the flash
		// function ct_random_color(){
		// 	let num = random(1,6);
		// 	// console.log(num);
		// 	let theme = {};
		// 	// Set primary, secondary and tertiary...
		// 	switch (num) {
		// 		case 1: case 2: 
		// 			theme = {color:'orange',primary:'F6921E',secondary:'8BC53F',tertiary:'993fc7'};
		// 			break;
		// 		case 3: case 4: 
		// 			theme = {color:'green',primary:'8BC53F',secondary:'F6921E',tertiary:'993fc7'};
		// 			break;
		// 		case 5:
		// 			theme = {color:'purple',primary:'993fc7',secondary:'F6921E',tertiary:'8BC53F'};
		// 			break;
		// 	}
		// 	// set Theme Variables
		// 	for(const color in theme){
		// 		if(color != 'color'){
		// 			document.querySelector('body').style.setProperty(`--${color}-color`, '#'+theme[color]);
		// 		}
		// 	}
		// 	window.ct_theme = theme;
		// 	// Add Theme Color to body class...
		// 	$('body').addClass('ct_'+theme.color)
		// }
		// ct_random_color();

		// console.log('ct_main gots tags: ', ct_tracking.tags);
		// console.log('ct_main gots domains: ', ct_tracking.domains);

		// Check for dataLayer
		if ( typeof dataLayer != 'undefined' ) {
			// Set cookie for logged in admins / editors to filter traffic
			if( $('body').hasClass('ct_internal_traffic') ) {
				createCookie('ct_internal_traffic', 'true', 365);
			}
			if( readCookie('ct_internal_traffic') ) {
					dataLayer.push({'ct_internal_traffic':'true'});
			}
		} else {
			console.log('Add Google Tag Manager to Divi Options Integrations Page and Install Google Tag Manager for WordPress Plugin to Set Up dataLayer for Enhanced Ecommerce Tracking and to exclude internal traffic.');
		}

		// general popup scripts...
		function ct_open_pop(){
			$('#ct_pop_over').css('display','flex');
		}
		$('.ct_open_pop').click(function(e){
			e.preventDefault();
			ct_open_pop();
			$('.multi_part_form').flickity('resize');
		});
		function ct_close_pop(){
			$('#ct_pop_over').css('display','none');
		}
		$('#ct_pop_over').click(function(e){
			if ( $(e.target).hasClass('ct_close_pop') || $(e.target).hasClass('ct_pop_over') ) {
				ct_close_pop();
			}
		});

		// multipart form
		$('.multi_part_form').flickity({adaptiveHeight: true, prevNextButtons: false, pageDots: false, draggable: false});
		
		window.ct_form_state = {};

		// function ct_get_label(input){
		// 	return input.parent().find('label').text();
		// }

		function ct_stripper(name, connect){
			// strip punctuation from name and return modified string.
			if(typeof connect == 'undefined'){ connect = '_'}
			return name.split(/[ .,\/\\\|'"#!$%\^&\*;:{}=\-_`~()]/g).filter(word => word).join(connect).toLowerCase();
		}

		// $('.ct_pop_over').find('form').each(function(){
		// 	let _form = $(this);
		// 	if (! _form.attr('name') ) { return; } else {
		// 		_form.connect_to_ninja(_form.attr('name'));
		// 	}
		// });

		function ct_nf_get_label(input){
			return input.closest('.field-wrap').find('label').text();
		}	

		function connect_to_ninja(){
			let ct_state = {};
			$('#nf-form-3-cont').find('.ninja-forms-field').each( function() {
				let theField = $(this);
				let theProperty = ct_stripper( ct_nf_get_label(theField) );
				theField.addClass('nf_'+theProperty);
				ct_state[theProperty] = {
					nf: '#'+theField[0].id,
					label: ct_nf_get_label(theField),
					val: false
				}
			});
			// console.log(ct_state);
		}
		function send_ninja(){
			// console.log('send_ninja');
			$('#nf-form-3-cont').find('.submit-container').find('input[type=button]').click();
		}






















		function nf_update(name, val){
			if ( val == 'checked'){
				$('#nf-form-3-cont').find('.nf_'+name).prop(val, true).trigger('change');
			} else {
				$('#nf-form-3-cont').find('.nf_'+name).val(val).trigger('change');
			}
		}

		function handle_input( the_input ) {
			let name = the_input.attr('name');
			let val = the_input.val();
			ct_form_state[name] = val;
			if (typeof name !== 'undefined') { 
				nf_update(name, val);
			}
		}
		
		function handle_click( the_click ) {
			let valid = true;
			the_click.closest('.form_part').children().filter(":input").each(function(){
				let field = $(this);
				if(field[0].validity.valid){
					// console.log(field.attr('name') +': Valid');
					field.removeClass('ct_error');
				} else {
					// console.log(field.attr('name') +': NOT valid');
					valid = false;
					field.addClass('ct_error');
					return;
				}
			});
			let name = the_click.attr('name');
			if (typeof name !== 'undefined') {
				ct_form_state[name] = true;
				nf_update(name, 'checked');
			}
			return valid;
		}

		$('.form_part').each(function (){
			let part = $(this);
			part.find('button').each(function(){
				let button = $(this);
				button.click(function(e){
					console.log('button click');
					e.preventDefault();
					let valid = handle_click( $(e.target) );
					console.log(ct_form_state);
					if (valid){
						console.log(valid);
						let _form = $(this).closest('.multi_part_form');
						let i = $(this).closest('.form_part').index();
						if ( $(e.target).hasClass('reserve') ) { 
							console.log('reserve_click');
							calendly_init(); 
							window.ct_calendly = true;
							_form.flickity('next'); 
							send_ninja();
						} else { 
							_form.flickity('next'); 
						}
					}
				});
			});
			part.children().filter(":input").each(function(){
				let input = $(this);
				input.change(function(e){
					handle_input( $(e.target) );
					// console.log(ct_form_state);
				});
			});
		});
		
		function isCalendlyEvent(e) {
			return e.origin === "https://calendly.com" && e.data.event && e.data.event.indexOf("calendly.") === 0;
		};

		function calendly_init(){
			// Dark Mode? get appropriate color scheme...
			if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
				window.ct_theme.bg = '333333';
				window.ct_theme.text = 'ffffff';
			} else {
				window.ct_theme.bg = 'eeeeee';
				window.ct_theme.text = '222222';
			}
			
			Calendly.initInlineWidget({
				url: `https://calendly.com/crowtoes/1qaw3edr5?hide_event_type_details=1&background_color=${ct_theme.bg}&text_color=${ct_theme.text}&primary_color=${ct_theme.primary}`,
				parentElement: document.getElementById('calendly_sched'),
				prefill: {
					name: ct_form_state.first_name +' '+ ct_form_state.last_name,
					email: ct_form_state.email_address,
					customAnswers: {
						a1: ct_form_state.project_details
					}
				},
				utm: {}
			});
			   
			window.addEventListener("message", function(e) {
				if(isCalendlyEvent(e)) {
					/* Example to get the name of the event */
					console.log(e.data.event.split('.').join('_'));
					dataLayer.push({'event' :'calendly_event',
						'cdy_step' : {
							'name' : e.data.event.split('.').join('_') 
						}
					});
					
					/* Example to get the payload of the event */
					console.log("Event details:", e.data.payload);
				}
			});
		}

		

		
		function ct_active_button(button){
			$('.et_pb_button').each(function(){ 
				$(this).removeClass('ct_active');
			});
			button.addClass('ct_active');
		}

		let ct_slider = $('#ct_slider').flickity({prevNextButtons: false,pageDots: false,initialIndex: 1});

		$('.ct_select_web_dev').click(function(e){
			e.preventDefault(); e.stopPropagation(); 
			ct_slider.flickity( 'select', 1 ); 
		});
		$('.ct_select_email_automation').click(function(e){
			e.preventDefault(); e.stopPropagation(); 
			ct_active_button($(this));
			ct_slider.flickity( 'select', 0 ); 
		});
		$('.ct_select_ecommerce').click(function(e){
			e.preventDefault(); e.stopPropagation(); 
			ct_active_button($(this));
			ct_slider.flickity( 'select', 2 ); 
		});

		ct_slider.on('select.flickity', function(event, index){
			if(index===0){
				ct_active_button($('.ct_select_email_automation'));
				$('.ct_big_logo').addClass('arrow_align_left');
				$('.ct_big_logo').removeClass('arrow_align_right');
			}
			if(index===1){
				ct_active_button($('.ct_select_web_dev'));
				$('.ct_big_logo').removeClass('arrow_align_left');
				$('.ct_big_logo').removeClass('arrow_align_right');
			}
			if(index===2){
				ct_active_button($('.ct_select_ecommerce'));
				$('.ct_big_logo').removeClass('arrow_align_left');
				$('.ct_big_logo').addClass('arrow_align_right');}
		});

		if (! builder ) {
			// listen for calendly schedule event
			function isCalendlyEvent(e) {
				return e.data.event && e.data.event.indexOf('calendly') === 0;
			};

			window.addEventListener( 'message', function(e) {
				if (isCalendlyEvent(e)) {
					// console.log(e);
					if ( e.data.event === "calendly.event_scheduled" ) {
						// console.log('THIS IS THE WAY');
						$('.lets_talk_title').hide();
					}
				}
			});

			// ninja form submission
			var mySubmitController = Marionette.Object.extend( {
	
				initialize: function() {
				this.listenTo( Backbone.Radio.channel( 'forms' ), 'submit:response', this.actionSubmit );
				},
			
				actionSubmit: function( response ) {
				// check for calendly.
					if ( typeof window.ct_calendly !== "undefined" ) {
						return;
					} else {
						$('.lets_talk_title').hide();
						$('.final_part').find('h3').css('padding', '1.5em 0em 1em').text('Thank you for your interest!');
						$('.final_part').append('<p>A representative will contact you shortly!</p>');
					}
				},
			
			});
			new mySubmitController();
		}

		// scroll effects
		$('.ct_logo_rotated').each(function(){
			
			let image = {}; 
			image.el = $(this).find('svg')[0];
			image.angle = 0;
			if(image.el){ image.angle = get_rotation_angle(image.el); }
			image.rotation_distance = image.angle * 2;
			image.rotation_stop = image.angle - image.rotation_distance;
			var rect = image.el.getBoundingClientRect();
			image.top = rect.top;
			$(window).on('scroll',function(e){
				let ct_frame = {}; 
				ct_frame.bottom = window.scrollY + window.innerHeight;
				ct_frame.top = window.scrollY;
				image.fromTop = image.top - window.scrollY;
				image.bottom = image.top + image.el.scrollHeight;
				image.traveled_percent = Math.round((image.fromTop / (window.innerHeight - image.el.scrollHeight))*100) / 100;
				image.newangle = Math.round((image.angle - (image.rotation_distance - (image.traveled_percent * image.rotation_distance)) + Number.EPSILON) * 100 ) / 100;
				// console.log(ct_frame.bottom > image.bottom && ct_frame.top < image.top ? 'In Frame' : 'Out of Frame');
				image.el.setAttribute('style','transform: rotate('+image.newangle+'deg)');
				// console.log(image.newangle);
			});
			// let degrees = 
		});
		

		$(window).load(function(){
			$('#ct_spinner_wrap').fadeOut(700);
			connect_to_ninja();
		});
	});
})( jQuery );


(function($){
	$(document).on('nfFormReady', function(){
		$('.other').on('change', function(){
			console.log($(this).val());
			if ($(this).val() == 'Other'){
				if( $(this).hasClass('other_1') ){
					$('.specify_1').closest('.specify').css('display','block');
				}
			}
		});
		$('[type=checkbox]').on('change', function(){
			let box = $(this);
			console.log(box.val());
			if (box.val() == 'Other'){
				if (box.is(':checked')){
					if( $(this).closest('.nf-field-container').hasClass('other_2') ){
						$('.specify_2').closest('.specify').css('display','block');
					} else {
						$('.specify_3').closest('.specify').css('display','block');
					}
				} else {
					if( $(this).closest('.nf-field-container').hasClass('other_2') ){
						$('.specify_2').closest('.specify').css('display','none');
					} else {
						$('.specify_3').closest('.specify').css('display','none');
					}
				}
			}
		});
	});
})(jQuery);